import { Row } from 'components/Blocks';
import { ArrowUpIcon } from 'components/Icons';

import { getPercentageDifference } from 'utils/percentage';

import { cn } from 'styles';

interface PercentageVariationProps {
  current: string | number;
  newValue: string | number;
}

export function PercentageVariation({ current, newValue }: PercentageVariationProps) {
  const delta = getPercentageDifference(current, newValue);

  if (!delta) return null;

  const isPositive = delta > 0;

  return (
    <Row gap="1">
      <ArrowUpIcon
        color={isPositive ? 'success-light' : 'destructive-light'}
        className={cn('transition-transform', !isPositive && 'rotate-180')}
      />

      <span
        className={cn(
          'font-semibold',
          isPositive ? 'text-success-light' : 'text-destructive-light',
        )}
      >
        {delta.toFixed(2)}%
      </span>
    </Row>
  );
}
